import { ChangeDetectionStrategy, Component, Inject, inject, OnDestroy, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { TranslateService } from '@ngx-translate/core'
import { filter, map, takeUntil, withLatestFrom } from 'rxjs/operators'

import { DestroyDirective } from '~/core/directives'
import { COMPANY_FACADE, ICompanyFacade } from '~/core/features'
import { IForecastDto } from '~/core/models'
import { MetaTagService } from '~/core/services'

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrl: './company.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [RouterOutlet],
})
export class CompanyComponent implements OnInit, OnDestroy {
  forecast?: IForecastDto | null
  private readonly destroy$ = inject(DestroyDirective).destroy$

  constructor(
    @Inject(COMPANY_FACADE) private companyFacade: ICompanyFacade,
    private translateService: TranslateService,
    private metaTagService: MetaTagService
  ) {}

  ngOnInit(): void {
    this.companyFacade.forecast$
      .pipe(
        takeUntil(this.destroy$),
        withLatestFrom(this.companyFacade.ticker$, this.translateService.get('forecast.notFoundForecastPageTitle')),
        map(([forecast, ticker, notFoundMessage]) => ({ forecast, ticker, notFoundMessage })),
        filter(({ ticker }) => Boolean(ticker))
      )
      .subscribe(({ forecast, ticker, notFoundMessage }) => {
        this.forecast = forecast
        forecast
          ? this.metaTagService.setTickerPageMeta(forecast.company.name, forecast.company.ticker)
          : this.metaTagService.setTickerNotFoundPageMeta(ticker!, notFoundMessage)
      })
  }

  ngOnDestroy(): void {
    this.metaTagService.setHomePageMeta()
  }
}
